export const collectionCardSx = {
    border: "none",
    borderRadius: 3,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06)",
    transition: "box-shadow 220ms ease, transform 180ms ease",
    "&:hover": {
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05), 0 12px 32px rgba(0, 0, 0, 0.09)",
    },
    "@media (prefers-reduced-motion: reduce)": {
        transition: "none",
    },
};

export const collectionCardContentSx = {
    flex: 1, minWidth: 0, p: 2.5,
    display: "flex", flexDirection: "column", gap: 2,
    "&:last-child": {pb: 2.5},
};

export const collectionCardTitleSx = {
    p: 0, minWidth: 0, color: "text.primary", fontSize: 16, fontWeight: 600,
    textAlign: "left", justifyContent: "flex-start", textTransform: "none",
    overflowWrap: "anywhere", lineHeight: 1.5,
};

export const collectionCardDescriptionSx = {
    mt: 0.75, fontSize: 13, color: "text.secondary", display: "-webkit-box",
    WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", overflowWrap: "anywhere",
};

export const collectionCardBadgeSx = {
    fontSize: 11, height: 22, border: "none", borderRadius: 2,
    bgcolor: "action.hover", color: "text.secondary",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
};
